import styled, { css } from 'styled-components';
import { getProgressColor } from './progressUtils';
import { mainTheme } from '../../../themes/mainTheme';
import { transition } from '../../../themes/mainTheme';

export const ProgressBarFill = styled.div<{
	$progress: number;
	$percent: number;
	$useDynamicColors: boolean;
}>`
	height: 8px;
	background-color: ${props => props.theme.progress.track};
	overflow: hidden;
	border-radius: 4px;
	position: relative;
	margin-bottom: 8px;

	&:after {
		content: '';
		width: ${({ $progress }) => `${$progress * 100}%`};
		height: 100%;
		max-width: 100%;
		position: absolute;
		top: 0;
		left: 0;

		background-color: ${({ $useDynamicColors, $percent }) =>
		$useDynamicColors ? getProgressColor($percent) : mainTheme.progress.success};

		transition: ${transition('width', 'background-color')};
	}
`;

export const ProgressBarWrapper = styled.div<{ $inline: boolean }>`
	padding: 0;

	${({ $inline }) =>
		$inline === true &&
		css`
			padding: 0 24px;
		`}
`;

export const ValueWrapper = styled.div`
	display: flex;
	flex-direction: row;
	align-items: center;
	justify-content: space-between;
	gap: 8px;
	width: 100%;
`;

export const Value = styled.p`
	font-size: 14px;
	font-weight: 400;
	font-family: ${props => props.theme.font};
	margin: 0;
	// Set explicitly rather than inherited — ancestors outside this component
	// were supplying an old-palette colour.
	color: ${props => props.theme.text.primary};
`;
